import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Loader from "../Loader/Loader";
import ReactPaginate from "react-paginate";
import LeadsModel from "./LeadsModel";
import swal from "sweetalert";

function Leads() {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  const [items, setItems] = useState([]);
  const [sortColumn, setSortColumn] = useState(null);
  const [order, setOrder] = useState("ASC");
  const [selectedLead, setSelectedLead] = useState(null);
  const [showModel, setShowModel] = useState(false);
  const [modelType, setModelType] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [allCampaign, setAllCampaign] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [filterKey, setFilterKey] = useState(0);

  const [showBranchModal, setShowBranchModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [currentLead, setCurrentLead] = useState(null);
  const [loadingLead, setLoadingLead] = useState(false);
  // Multi-select states
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState({});
  const [historyLoadingId, setHistoryLoadingId] = useState(null);
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    phone: "",
    destination: "",
    city: "",
    assigned_user_id: "",
    initial_status: "",
    followup_1_status: "",
    followup_2_status: "",
    final_status: "",
    sort_by: "",
    sort_dir: "asc",
    start_date: "",
    end_date: "",
    is_favorite: null,
  });
  const [leadStatus, setLeadStatus] = useState("");

  const tableHeader = [
    { title: "Select", dataKey: null, key: "select" },
    {
      title: (
        <span className="d-flex justify-content-center align-items-center gap-1">
          <span>Favorite</span>
          <span className="text-warning">
            <FaIcons.FaStar />
          </span>
        </span>
      ),
      dataKey: "is_favorite",
      key: "favorite",
      align: "text-center",
      width: "8%",
    },
    { title: "Client Name", dataKey: "client_name", key: "client_name" },
    { title: "Phone", dataKey: "phone", key: "phone" },
    { title: "Email", dataKey: "email", key: "email" },
    { title: "City", dataKey: "city", key: "city" },
    {
      title: "Destination Country",
      dataKey: "destination_country",
      key: "destination_country",
    },
    { title: "Previous Education", dataKey: "education", key: "education" },
    { title: "Intended Course", dataKey: "course", key: "course" },
    {
      title: "CGPA",
      dataKey: "academic_cgpa",
      key: "academic_cgpa",
    },
    {
      title: "Percentage",
      dataKey: "academic_percentage	",
      key: "academic_percentage	",
    },
    {
      title: "English Test",
      dataKey: "eng_test",
      key: "eng_test",
    },
    { title: "Max Budget", dataKey: "budget_max", key: "budget_max" },
    {
      title: "Initial Status",
      dataKey: "initial_status",
      key: "initial_status",
    },
    {
      title: "First Followup",
      dataKey: "followup_1_status",
      key: "followup_1_status",
    },
    {
      title: "Seconds Followup",
      dataKey: "followup_2_status",
      key: "followup_2_status",
    },
    { title: "Final Status", dataKey: "final_status", key: "final_status" },
    { title: "Lead Status", dataKey: "score", key: "score" },
    {
      title: "Assigned To",
      dataKey: "assigned_user_id",
      key: "assigned_user_id",
    },
    {
      title: "Assigned At",
      dataKey: "assigned_at",
      key: "assigned_at",
    },
    { title: "Created at", dataKey: "created_at", key: "created_at" },
    { title: "Actions", dataKey: null, key: "actions" },
  ];

  // Multi-select functions
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedRows(items.map((item) => item.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (leadId) => {
    setSelectedRows((prev) => {
      if (prev.includes(leadId)) {
        const newSelected = prev.filter((id) => id !== leadId);
        setSelectAll(newSelected.length === items.length);
        return newSelected;
      } else {
        const newSelected = [...prev, leadId];
        setSelectAll(newSelected.length === items.length);
        return newSelected;
      }
    });
  };

  // get cmapaigns
  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const response = await apiUrl.get("/getAllActiveCampaign");
      if (response?.status) {
        setAllCampaign(response?.data?.data);

        if (!selectedCampaign) {
          const firstCampaign = response.data.data[0].id;
          setSelectedCampaign(firstCampaign);
        }
      } else {
        setAllCampaign([]);
        setSelectedCampaign("");
      }
    } catch (err) {
      console.error("Failed to load campaigns", err);
    }
  };
  // Clear selections when items change
  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
  }, [items]);

  useEffect(() => {
    if (selectedCampaign) {
      setPagination((prev) => ({
        ...prev,
        currentPage: 1,
      }));
    }
  }, [selectedCampaign]);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  // Delete multiple leads
  const handleDeleteSelected = async () => {
    if (selectedRows.length === 0) {
      swal("Warning!", "Please select at least one lead to delete.", "warning");
      return;
    }

    const confirmDelete = await swal({
      title: "Are you sure?",
      text: `You want to delete ${selectedRows.length} selected lead(s)!`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmDelete) {
      try {
        setLoading(true);
        const response = await apiUrl.post("deleteCompaignLeads", {
          lead_ids: selectedRows,
        });

        if (response?.data?.status) {
          swal(
            "Deleted!",
            `${selectedRows.length} lead(s) deleted successfully.`,
            "success",
          );
          setSelectedRows([]);
          setSelectAll(false);
          fetchLeads();
        } else {
          swal(
            "Failed!",
            response?.data?.message || "Something went wrong.",
            "error",
          );
        }
      } catch (error) {
        console.error("Delete Error:", error);
        swal("Error!", "Something went wrong while deleting.", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (selectedCampaign) {
      fetchLeads();
    }
  }, [selectedCampaign, pagination.currentPage, pagination.perPage, filterKey]);

  const sorting = (col) => {
    if (!col) return; // Don't sort on select column

    const sorted = [...items].sort((a, b) => {
      const valA = a[col]?.toString().toLowerCase();
      const valB = b[col]?.toString().toLowerCase();
      if (order === "ASC") {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });
    setItems(sorted);
    setOrder(order === "ASC" ? "DESC" : "ASC");
    setSortColumn(col);
  };

  const fetchLeads = async () => {
    setLoading(true);
    setItems([]);
    try {
      const params = {
        perPage: pagination.perPage,
        page: pagination.currentPage,
        campaign_id: selectedCampaign,
        status: leadStatus,
        ...filters,
      };
      const response = await apiUrl.get("fetchLeads", { params });
      if (response?.data?.status) {
        const { items: dataItems, meta: dataMeta } = response.data.data;
        setPagination((prev) => ({
          ...prev,
          total: dataMeta.total,
          lastPage: dataMeta.lastPage,
          perPage: dataMeta.perPage,
          currentPage: dataMeta.currentPage,
        }));
        setItems(dataItems);
        return { dataItems };
      } else {
        console.error("Failed to fetch leads:", response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("items", items);
  const getStatusCode = async () => {
    try {
      const response = await apiUrl.get("getStatusCodes");
      if (response?.data?.data) {
        const statusData = response.data.data;
        setSelectedOptions(statusData);
      }
    } catch (error) {
      console.error("Error fetching status codes:", error);
    }
  };

  const getAllUsers = async () => {
    try {
      const response = await apiUrl.get("fetchAllActiveUsers");
      if (response?.data?.data) {
        const allUsers = response.data.data;
        setAllUsers(allUsers);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  useEffect(() => {
    const perms = getPermissions();
    if (perms) {
      getStatusCode();
      getAllUsers();
      setPermissions(perms);
    }
  }, []);

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const OpenModel = (lead, type) => {
    setSelectedLead(lead);
    setShowModel(true);
    setModelType(type);
  };

  const closeModal = () => {
    setShowModel(false);
    setSelectedLead(null);
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearAllFilters = async () => {
    setFilters({
      name: "",
      email: "",
      phone: "",
      destination: "",
      city: "",
      assigned_user_id: "",
      initial_status: "",
      followup_1_status: "",
      followup_2_status: "",
      final_status: "",
      sort_by: "",
      sort_dir: "asc",
      start_date: "",
      end_date: "",
    });
    setLeadStatus("");
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    setFilterKey((prev) => prev + 1);
  };

  const handleSearch = async () => {
    if (filters.start_date && filters.end_date) {
      const start = new Date(filters.start_date);
      const end = new Date(filters.end_date);
      if (end < start) {
        swal(
          "Invalid Date Range!",
          "End date must be on or after start date.",
          "error",
        );
        return;
      }
    }
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    setFilterKey((prev) => prev + 1);
  };
  // handle assigned user
  const handleAssignUser = async (e) => {
    if (selectedRows.length === 0) {
      swal("Warning!", "Please select at least one lead to delete.", "warning");
      return;
    }
    const userId = e.target.value;
    const selectedUser = allUsers.find((user) => user.id == userId);
    setSelectedUser(userId);

    const confirmAssign = await swal({
      title: "Are you sure?",
      text: `You want to Assign ${selectedRows.length} selected lead(s)! to User ${selectedUser?.name}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmAssign) {
      try {
        setLoading(true);
        const response = await apiUrl.post("assignLeadsToUser", {
          lead_ids: selectedRows,
          user_id: userId,
        });

        if (response?.data?.status) {
          swal(
            "Assigned!",
            `${selectedRows.length} lead(s) Assigned successfully.`,
            "success",
          );
          setSelectedRows([]);
          setSelectAll(false);
          setSelectedUser(null);
          fetchLeads();
        } else {
          swal(
            "Failed!",
            response?.data?.message || "Something went wrong.",
            "error",
          );
        }
      } catch (error) {
        swal("Error!", "Something went wrong while Assigned Leads.", "error");
      } finally {
        setLoading(false);
      }
    }
  };
  const handleMoveToClient = async (lead) => {
    setCurrentLead(lead);
    setShowBranchModal(true);
  };
  useEffect(() => {
    if (showBranchModal) {
      fetchBranches();
    }
  }, [showBranchModal]);
  const fetchBranches = async () => {
    try {
      const response = await apiUrl.get("/getAgentsByOffice");
      if (response?.data?.status) {
        setBranches(response.data.data);
      } else {
        setBranches([]);
      }
    } catch (err) {
      console.error("Failed to load branches", err);
      setBranches([]);
    }
  };
  const handleConfirmMoveWithBranch = async () => {
    if (!selectedBranch || !currentLead) {
      swal("Error!", "Please select a branch.", "error");
      return;
    }
    let data = {
      selectedBranch,
      currentLead,
    };
    try {
      setLoadingLead(true);
      const response = await apiUrl.post("/leadToClient", data);
      if (response.status) {
        swal("Moved!", `Lead Moved to Client successfully.`, "success");
        await fetchLeads();
        setShowBranchModal(false);
        setSelectedBranch("");
        setCurrentLead(null);
        setSelectedLead(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingLead(false);
    }
  };

  const fetchLeadHistory = async (leadId) => {
    setHistoryLoadingId(leadId);
    try {
      const response = await apiUrl.get(`/leads/${leadId}/status-history`);
      console.log(response);
      if (response?.status) {
        setHistoryData(response?.data?.data || []);
        setOpenHistoryModal(true);
      } else {
        swal(
          "Error",
          response.data?.message || "Failed to load history",
          "error",
        );
        setHistoryData([]);
      }
    } catch (err) {
      console.error("History fetch error:", err);
      swal("Error", "Could not load lead history", "error");
      setHistoryData([]);
    } finally {
      setHistoryLoadingId(null);
    }
  };

  const toggleFavorite = async (leadId) => {
    try {
      const response = await apiUrl.patch(`/leads/${leadId}/toggle-favorite`);
      if (response?.status) {
        fetchLeads();
      }
    } catch (err) {
      console.error("Toggle favorite failed:", err);

      swal(
        "Error",
        err.response?.data?.message || "Failed to pin/unpin lead",
        "error",
      );
    }
  };
  const leadStatusOptions = [
    { value: "", label: "All" },
    { value: "very_good", label: "Very Good" },
    { value: "good", label: "Good" },
    { value: "average", label: "Average" },
    { value: "poor", label: "Poor" },
  ];
  return (
    <>
      <div className="container-fluid px-2 py-3">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-12 px-4">
            <div className="d-flex items-center justify-content-between gap-2">
              <div className="d-flex align-items-center mb-4">
                <a
                  className="btn btn-link p-0 me-3"
                  onClick={() => navigate("/dashboard")}
                  style={{ textDecoration: "none" }}
                >
                  <FaIcons.FaArrowAltCircleLeft size={22} className="me-1" />
                  <span className="fw-bold">Back</span>
                </a>
                <h2 className="mb-0 fw-bold">Campaign Leads</h2>
              </div>
              <div className="d-flex justify-content-end align-items-end gap-2 ">
                {/* Assigned Selected */}
                <div
                  style={{
                    width: "300px",
                  }}
                >
                  {!!permissions.delete_campaign_leads &&
                    selectedRows.length > 0 && (
                      <select
                        className="form-select mb-2"
                        name="assigned_user_id"
                        value={selectedUser || ""}
                        onChange={handleAssignUser}
                      >
                        <option value="">Select User</option>
                        {allUsers.map((user) => (
                          <option key={user.id} value={user.id.toString()}>
                            {user?.name}
                          </option>
                        ))}
                      </select>
                    )}
                </div>

                {/* Delete Selected Button */}
                {!!permissions.delete_campaign_leads &&
                  selectedRows.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-danger px-4 mb-2"
                      onClick={handleDeleteSelected}
                    >
                      <FaIcons.FaTrash className="me-1" />
                      Delete Selected ({selectedRows.length})
                    </button>
                  )}
                {!!permissions.delete_campaign_leads && (
                  <button
                    type="button"
                    className="btn btn-primary px-4 mb-2"
                    onClick={() => navigate("/add_leads")}
                  >
                    <FaIcons.FaRegPlusSquare className="me-1" />
                    Add Leads
                  </button>
                )}
                {!!permissions.delete_campaign_leads && (
                  <button
                    type="button"
                    className="btn btn-primary px-4 mb-2"
                    onClick={() => navigate("/campaigns")}
                  >
                    <FaIcons.FaLevelUpAlt className="me-1" />
                    Compaigns
                  </button>
                )}
              </div>
            </div>
            {/* campaign selection drop-down */}
            {!!permissions.delete_campaign_leads && (
              <div className="mb-2 col-md-6">
                <label className="form-label fw-bold">
                  Select Campaign <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={selectedCampaign}
                  onChange={(e) => {
                    setSelectedCampaign(e.target.value);
                    setPagination((prev) => ({
                      ...prev,
                      currentPage: 1,
                    }));
                  }}
                  required
                >
                  <option value="" disabled>
                    -- Select a Campaign --
                  </option>
                  {allCampaign.map((camp) => (
                    <option key={camp.id} value={camp.id}>
                      {camp.name} ({camp.campaign_code}) -{" "}
                      {camp.created_at.split("T")[0]}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* Filters section */}
            {!!permissions.delete_campaign_leads && (
              <div className="card shadow-sm mb-4 border-0 bg-light">
                <div className="card-body pb-2">
                  <form>
                    <div className="d-flex flex-wrap gap-2 align-items-end">
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <input
                            type="text"
                            id="name"
                            className="form-control"
                            placeholder="Name"
                            value={filters.name}
                            onChange={(e) =>
                              handleFilterChange("name", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <input
                            type="text"
                            id="email"
                            className="form-control"
                            placeholder="Email"
                            value={filters.email}
                            onChange={(e) =>
                              handleFilterChange("email", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <input
                            type="text"
                            id="phone"
                            className="form-control"
                            placeholder="phone"
                            value={filters.phone}
                            onChange={(e) =>
                              handleFilterChange("phone", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <input
                            type="text"
                            id="destination"
                            className="form-control"
                            placeholder="destination"
                            value={filters.destination}
                            onChange={(e) =>
                              handleFilterChange("destination", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <input
                            type="text"
                            id="city"
                            className="form-control"
                            placeholder="city"
                            value={filters.city}
                            onChange={(e) =>
                              handleFilterChange("city", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <select
                            id="assigned_user_id"
                            className="form-select"
                            value={filters.assigned_user_id}
                            onChange={(e) =>
                              handleFilterChange(
                                "assigned_user_id",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Assigned To</option>
                            {allUsers &&
                              allUsers.map((user, idx) => {
                                return (
                                  <option key={idx} value={user?.id}>
                                    {user?.name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <select
                            id="initial_status"
                            className="form-select"
                            value={filters.initial_status}
                            onChange={(e) =>
                              handleFilterChange(
                                "initial_status",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Initial Status</option>
                            {selectedOptions &&
                              selectedOptions.map((option, idx) => {
                                const label = option?.label;
                                return (
                                  <option key={idx} value={option?.id}>
                                    {label}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <select
                            id="followup_1_status"
                            className="form-select"
                            value={filters.followup_1_status}
                            onChange={(e) =>
                              handleFilterChange(
                                "followup_1_status",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">First Followup</option>
                            {selectedOptions &&
                              selectedOptions.map((option, idx) => {
                                const label = option?.label;
                                return (
                                  <option key={idx} value={option?.id}>
                                    {label}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <select
                            id="followup_2_status"
                            className="form-select"
                            value={filters.followup_2_status}
                            onChange={(e) =>
                              handleFilterChange(
                                "followup_2_status",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Second Followup</option>
                            {selectedOptions &&
                              selectedOptions.map((option, idx) => {
                                const label = option?.label;
                                return (
                                  <option key={idx} value={option?.id}>
                                    {label}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div style={{ minWidth: 180, flex: 1 }}>
                        <div className="input-group">
                          <select
                            id="final_status"
                            className="form-select"
                            value={filters.final_status}
                            onChange={(e) =>
                              handleFilterChange("final_status", e.target.value)
                            }
                          >
                            <option value="">Final Status</option>
                            {selectedOptions &&
                              selectedOptions.map((option, idx) => {
                                const label = option?.label;
                                return (
                                  <option key={idx} value={option?.id}>
                                    {label}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-2 mt-1">
                      <div style={{ minWidth: 180 }}>
                        <label className="form-label small">Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={filters.start_date}
                          onChange={(e) =>
                            handleFilterChange("start_date", e.target.value)
                          }
                        />
                      </div>
                      <div style={{ minWidth: 180 }}>
                        <label className="form-label small">End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={filters.end_date}
                          onChange={(e) =>
                            handleFilterChange("end_date", e.target.value)
                          }
                        />
                      </div>
                      {/* Lead Status */}
                      <div className="col-2 mt-1">
                        <label className="block text-sm font-medium text-gray-600 mb-1">
                          Lead Status
                        </label>
                        <select
                          className="w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring-2 focus:ring-blue-500"
                          value={leadStatus}
                          onChange={(e) => setLeadStatus(e.target.value)}
                        >
                          {leadStatusOptions?.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-3 gap-2">
                      <div>
                        <select
                          className="form-select mb-2"
                          name="assigned_user_id"
                          value={filters?.is_favorite || ""}
                          onChange={(e) => {
                            setFilters((pre) => ({
                              ...pre,
                              is_favorite: e.target.value,
                            }));
                            setFilterKey((pre) => pre + 1);
                            setPagination((pre) => ({
                              ...pre,
                              currentPage: 1,
                            }));
                          }}
                        >
                          <option value="">All Leads</option>
                          <option value="true" className="text-warning">
                            Starred Leads
                          </option>
                          <option value="false">Unstarred Leads</option>
                        </select>
                      </div>

                      <button
                        type="button"
                        className="btn btn-outline-secondary px-4"
                        onClick={clearAllFilters}
                      >
                        Clear All
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary px-4"
                        onClick={handleSearch}
                      >
                        <FaIcons.FaSearch className="me-1" /> Apply Filters
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* table section */}
            <div
              className="card shadow-sm mb-4"
              style={{ borderRadius: "1rem" }}
            >
              <div className="card-body p-0">
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <Loader />
                  </div>
                ) : (
                  <div
                    className="table-responsive mb-2"
                    style={{ borderRadius: "1rem" }}
                  >
                    <table className="table table-bordered table-hover bg-white mb-0">
                      <thead className="table-dark">
                        <tr>
                          {tableHeader.map((header, index) => (
                            <th
                              key={header.key}
                              className={`text-center align-middle ${
                                header.dataKey ? "pointer" : ""
                              }`}
                              onClick={() => sorting(header.dataKey)}
                              style={
                                header.key === "select" ? { width: "60px" } : {}
                              }
                            >
                              {header.key === "select" ? (
                                <div
                                  className="text-center align-middle position-relative"
                                  style={{
                                    width: "60px",
                                    minWidth: "60px",
                                    maxWidth: "60px",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAll}
                                    className="form-check-input"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              ) : (
                                <>
                                  {header.title}
                                  {sortColumn === header.dataKey && (
                                    <span className="ms-1">
                                      {order === "ASC" ? (
                                        <FaIcons.FaArrowUp />
                                      ) : (
                                        <FaIcons.FaArrowDown />
                                      )}
                                    </span>
                                  )}
                                </>
                              )}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {items && items.length > 0 ? (
                          items.map((item, index) => (
                            <tr
                              key={item?.id}
                              className={
                                selectedRows.includes(item.id)
                                  ? "table-primary"
                                  : ""
                              }
                            >
                              <td
                                className="text-center align-middle position-relative"
                                style={{
                                  width: "60px",
                                  minWidth: "60px",
                                  maxWidth: "60px",
                                }}
                              >
                                <div className="d-flex justify-content-center">
                                  <input
                                    type="checkbox"
                                    checked={selectedRows.includes(item.id)}
                                    onChange={() => handleRowSelect(item.id)}
                                    className="form-check-input"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              </td>
                              <td className="text-center align-middle">
                                <button
                                  className="btn p-1"
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                  }}
                                  onClick={() => toggleFavorite(item.id)}
                                  title={
                                    item.is_favorite ? "Unpin" : "Pin this lead"
                                  }
                                  disabled={loading}
                                >
                                  {item.is_favorite ? (
                                    <FaIcons.FaStar
                                      className="text-warning"
                                      size={18}
                                    />
                                  ) : (
                                    <FaIcons.FaRegStar
                                      className="text-muted"
                                      size={18}
                                    />
                                  )}
                                </button>
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.client_name}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.phone}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.email}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.city}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.destination_country}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.education}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.course}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.academic_cgpa}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.academic_percentage}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.eng_test}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.budget_max}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {selectedOptions?.find(
                                  (option) => option.id == item.initial_status,
                                )?.label || ""}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {selectedOptions?.find(
                                  (option) =>
                                    option.id == item.followup_1_status,
                                )?.label || ""}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {selectedOptions?.find(
                                  (option) =>
                                    option.id == item.followup_2_status,
                                )?.label || ""}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {selectedOptions?.find(
                                  (option) => option.id == item.final_status,
                                )?.label || ""}
                              </td>
                              <td className="p-3 text-center align-middle">
                                {item?.score?.score_category ? (
                                  <span
                                    className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${
                                      item.score.score_category === "Very Good"
                                        ? "bg-green-100 text-green-700"
                                        : item.score.score_category === "Good"
                                          ? "bg-blue-100 text-blue-700"
                                          : item.score.score_category ===
                                              "Average"
                                            ? "bg-yellow-100 text-yellow-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                  >
                                    {item.score.score_category.toUpperCase()}
                                  </span>
                                ) : (
                                  "--"
                                )}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {allUsers?.find(
                                  (user) => user.id === item.assigned_user_id,
                                )?.name || ""}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {item?.assigned_at
                                  ? new Date(item.assigned_at).toLocaleString(
                                      "en-GB",
                                      {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      },
                                    )
                                  : "--"}
                              </td>
                              <td className="text-center align-middle position-relative">
                                {new Date(item.created_at).toLocaleString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )}
                              </td>
                              <td className="text-center align-middle position-relative">
                                <div className="d-flex justify-content-center gap-2">
                                  {!!permissions.view_campaign_leads && (
                                    <button
                                      className="btn btn-primary p-1"
                                      title="View Lead"
                                      onClick={() => OpenModel(item, "view")}
                                    >
                                      <FaIcons.FaEye size={16} />
                                    </button>
                                  )}
                                  {!!permissions.edit_campaign_leads && (
                                    <button
                                      className="btn btn-warning p-1"
                                      title="Edit Lead"
                                      onClick={() => OpenModel(item, "edit")}
                                    >
                                      <FaIcons.FaEdit size={16} />
                                    </button>
                                  )}
                                  {!item.moved_to_client && (
                                    <button
                                      className="btn btn-success p-1"
                                      title="Move to Client"
                                      onClick={() => handleMoveToClient(item)}
                                      disabled={loading}
                                    >
                                      <FaIcons.FaUserPlus size={16} />
                                    </button>
                                  )}
                                  {!!item.moved_to_client && (
                                    <span className="badge bg-success">
                                      Moved <br /> to client
                                    </span>
                                  )}
                                  {!!permissions.delete_campaign_leads && (
                                    <button
                                      className="btn btn-info p-1 d-flex align-items-center justify-content-center"
                                      title="Lead History"
                                      onClick={() => fetchLeadHistory(item.id)}
                                      disabled={historyLoadingId === item.id}
                                    >
                                      {historyLoadingId === item.id ? (
                                        <div
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                        ></div>
                                      ) : (
                                        <FaIcons.FaHistory size={16} />
                                      )}
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={tableHeader.length}
                              className="text-center"
                            >
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            {/* history of lead  */}
            {/* Lead History Modal */}
            {openHistoryModal && (
              <>
                <div
                  className="modal-backdrop fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                  onClick={() => {
                    setOpenHistoryModal(false);
                    setHistoryData([]);
                  }}
                />
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{ zIndex: 1055 }}
                >
                  <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header text-white">
                        <h5 className="modal-title">Lead Status History</h5>
                        <button
                          type="button"
                          className="btn-close btn-close-white"
                          onClick={() => {
                            setOpenHistoryModal(false);
                            setHistoryData([]);
                          }}
                        />
                      </div>

                      <div
                        className="modal-body p-0"
                        style={{ maxHeight: "70vh", overflow: "auto" }}
                      >
                        {historyLoadingId ? (
                          <div className="d-flex justify-content-center py-4">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : historyData?.history?.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-hover mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th>#</th>
                                  <th>User</th>
                                  <th>Field</th>
                                  <th>From → To</th>
                                  <th>When</th>
                                </tr>
                              </thead>
                              <tbody>
                                {historyData?.history.map((log, idx) => (
                                  <tr key={log.id}>
                                    <td width="5%">{idx + 1}</td>
                                    <td width="20%">
                                      <small className="fw-bold text-primary">
                                        {log.user_name}
                                      </small>
                                    </td>
                                    <td width="20%">
                                      {log.field === "initial_status" && (
                                        <span className="badge bg-primary">
                                          {log.field}
                                        </span>
                                      )}
                                      {log.field === "followup_1_status" && (
                                        <span className="badge bg-success">
                                          {log.field}
                                        </span>
                                      )}
                                      {log.field === "followup_2_status" && (
                                        <span className="badge bg-warning text-dark">
                                          {log.field}
                                        </span>
                                      )}
                                      {log.field === "final_status" && (
                                        <span className="badge bg-danger">
                                          {log.field}
                                        </span>
                                      )}
                                    </td>
                                    <td width="38%">
                                      <del className="text-muted me-1">
                                        {log.old_value}
                                      </del>
                                      <strong className="text-success">
                                        → {log.new_value}
                                      </strong>
                                    </td>
                                    <td width="17%">
                                      <small className="text-muted">
                                        {new Date(
                                          log.changed_at + "Z",
                                        ).toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "short",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}
                                      </small>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="text-center py-4 text-muted">
                            No status changes recorded yet.
                          </div>
                        )}
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            setOpenHistoryModal(false);
                            setHistoryData([]);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* pagination section */}
            <div className="row align-items-center mb-5 mt-2">
              <div className="col-auto">
                <select
                  value={pagination?.perPage}
                  onChange={handlePerPageChange}
                  className="form-select"
                  style={{ minWidth: 80 }}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
              <div className="col-auto text-muted">
                Page {pagination.currentPage} – Showing{" "}
                {Math.min(
                  pagination.perPage,
                  pagination.total -
                    (pagination.currentPage - 1) * pagination.perPage,
                )}{" "}
                of {pagination.total} entries
              </div>
              <div className="col">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pagination.lastPage}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageChange}
                  forcePage={pagination.currentPage - 1}
                  containerClassName={"pagination justify-content-end mb-0"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  disabledClassName={"disabled"}
                />
              </div>
            </div>

            <LeadsModel
              show={showModel}
              onClose={closeModal}
              type={modelType}
              lead={selectedLead}
              fetchLeads={fetchLeads}
            />
          </div>

          {/* Branch Selection Modal */}
          {showBranchModal && currentLead && (
            <>
              {/* Backdrop */}
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
                onClick={() => {
                  setShowBranchModal(false);
                  setSelectedBranch("");
                  setCurrentLead(null);
                  setSelectedLead(null);
                }}
              />

              {/* Modal */}
              <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
                style={{ zIndex: 1050 }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div
                    className="modal-content border-0 rounded-4 shadow"
                    style={{ overflow: "hidden" }}
                  >
                    {/* Header */}
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <div>
                        <h5
                          className="modal-title text-dark"
                          style={{ fontWeight: 700 }}
                        >
                          Move Lead to Client
                        </h5>
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          This action cannot be undone.
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                          setShowBranchModal(false);
                          setSelectedBranch("");
                          setCurrentLead(null);
                          setSelectedLead(null);
                        }}
                      />
                    </div>

                    {/* Body */}
                    <div className="modal-body">
                      <div className="alert alert-warning mb-4">
                        <FaIcons.FaExclamationTriangle className="me-2" />
                        <strong>Warning:</strong> This action cannot be undone.
                        You are moving{" "}
                        <strong>{currentLead?.client_name}</strong> to client.
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          Branch <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={selectedBranch}
                          onChange={(e) => setSelectedBranch(e.target.value)}
                          required
                        >
                          <option value="" disabled>
                            -- Select Branch --
                          </option>
                          {branches.map((branch) => (
                            <option key={branch.id} value={branch.id}>
                              {branch.agencyname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Footer */}
                    <div
                      className="modal-footer"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          setShowBranchModal(false);
                          setSelectedBranch("");
                          setCurrentLead(null);
                          setSelectedLead(null);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleConfirmMoveWithBranch}
                        disabled={!selectedBranch}
                      >
                        {loadingLead ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Moving...
                          </>
                        ) : (
                          <> Confirm Move</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Leads;
